import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PagedSearch, DatagridService, PagedResultGeneric } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { FinancialApiService } from '../../shared/financial-api.service';
import { FinancialServiceService } from '../../shared/financial.service';
import { AccountingPackageJournalEntry } from '../../shared/transaction/dto/accounting-package-journal-entry.dto';
import { TransactionSearchV2Dto } from '../../shared/transaction/dto/transaction-searchv2.dto';

@Component({
  selector: 'wl-journal-entries-grid',
  templateUrl: './journal-entries-grid.component.html',
  styleUrls: ['./journal-entries-grid.component.less'],
    standalone: false
})
export class JournalEntriesGridComponent extends LazySelectableTableComponent<TransactionSearchV2Dto, AccountingPackageJournalEntry> {
  @Input() searchDto: TransactionSearchV2Dto;
  exporting: boolean = false;
  constructor(
    datagridService: DatagridService,
    public _financialService: FinancialServiceService,
    private _navigationService: NavigationService
  ) {
    super('', datagridService);
    this.searchParams = this.searchDto ?? ({ PageNumber: 1, PageSize: 20 } as TransactionSearchV2Dto);
  }

  fetchResults(): Promise<PagedResultGeneric<AccountingPackageJournalEntry>> {
    this.setSearchParams();
    return this._financialService.getJournalEntries(this.searchParams);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  exportResults() {
    this.exporting = true;
    this._financialService
      .exportJournalEntries(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
  private setSearchParams() {
    this.searchParams.Account = this.searchDto.Account;
    this.searchParams.AccountingPackageID = this.searchDto.AccountingPackageID;
    this.searchParams.ApplyDateEnd = this.searchDto.ApplyDateEnd;
    this.searchParams.ApplyDateStart = this.searchDto.ApplyDateStart;
    this.searchParams.BatchPosting = this.searchDto.BatchPosting;
    this.searchParams.DatePostedEnd = this.searchDto.DatePostedEnd;
    this.searchParams.DatePostedStart = this.searchDto.DatePostedStart;
    this.searchParams.TransactionType = this.searchDto.TransactionType;
  }
}
